// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-dropdown-menu {
  padding: 12px;
  cursor: pointer;
  height: 40px;
}
.user-dropdown-menu a {
  text-decoration: none;
  color: #000;
  padding-right: 5px !important;
}
.user-dropdown-menu:hover {
  background-color: #989898;
}
`, "",{"version":3,"sources":["webpack://./src/app/capd-admin-component/capd-admin.component.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AADF;AAIA;EACE,qBAAA;EACA,WAAA;EACA,6BAAA;AAFF;AAKA;EACE,yBAAA;AAHF","sourcesContent":["@import \"@mmodal/aura-less-variables/base/_colors.less\";\n\n.user-dropdown-menu {\n  padding: 12px;\n  cursor: pointer;\n  height: 40px;\n}\n\n.user-dropdown-menu a {\n  text-decoration: none;\n  color: #000;\n  padding-right: 5px !important;\n}\n\n.user-dropdown-menu:hover {\n  background-color: #989898;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
